import { useEffect, useRef, useState } from "react";
import { LuVolume2, LuVolumeX } from "react-icons/lu";
import { useApp } from "../store";
import { canSpeak, questionToSpeech, readMode, speak, stopSpeaking } from "../speech";

/**
 * A loudspeaker button on a question. In "auto" mode the question is also read out as soon as it appears.
 * Hidden when the pupil switched reading off (Profil → Indstillinger) or the browser cannot speak.
 */
export function ReadAloud({ q, id }: { q: { text: string; kind: string; options: string[] }; id: string }) {
  const { me } = useApp();
  const mode = readMode(me?.grade);
  const [on, setOn] = useState(false);
  const qRef = useRef(q);
  qRef.current = q;
  const supported = canSpeak();

  useEffect(() => {
    if (!supported || mode !== "auto") return;
    const t = setTimeout(() => speak(questionToSpeech(qRef.current), setOn), 450);
    return () => { clearTimeout(t); stopSpeaking(); setOn(false); };
  }, [id, mode, supported]);
  useEffect(() => () => stopSpeaking(), []);

  if (!supported || mode === "off") return null;
  return (
    <button
      type="button"
      className={`readbtn${on ? " speaking" : ""}`}
      aria-label={on ? "Stop oplæsning" : "Læs spørgsmålet op"}
      aria-pressed={on}
      onClick={() => { if (on) { stopSpeaking(); setOn(false); } else speak(questionToSpeech(q), setOn); }}
    >
      {on ? <LuVolumeX aria-hidden="true" size={22} /> : <LuVolume2 aria-hidden="true" size={22} />}
      <span>{on ? "Stop" : "Læs op"}</span>
    </button>
  );
}
